import { useSelector } from 'react-redux';
import { useAssetBucketQuery } from './api/useAssetBucketQuery';
import { useAdvisorAssetBucketQuery } from './api/useAdvisorAssetBucketQuery';
import { selectHasAdvisorAssetBucketingLayoutAccess } from '../../../CommonSelectors/CommonAreaSelector';

export const useAssetBucketing = () => {
  const hasAdvisorAssetBucketingLayoutAccess = useSelector(
    selectHasAdvisorAssetBucketingLayoutAccess,
  );

  const firmQueryInfo = useAssetBucketQuery(!hasAdvisorAssetBucketingLayoutAccess);
  const advisorQueryInfo = useAdvisorAssetBucketQuery(hasAdvisorAssetBucketingLayoutAccess);

  return hasAdvisorAssetBucketingLayoutAccess ? advisorQueryInfo : firmQueryInfo;
};
